/**
 * Base environment configuration with default values.
 * This file contains sensible defaults that will be overridden at runtime
 * by the configuration returned from /api/tms/v1/environment endpoint.
 * 
 * Customer-specific settings are fetched from the backend upon application start,
 * allowing a single build to work for all customers.
 * 
 * See DEPLOYMENT.md for deployment instructions.
 */
export const environment: any = {
    // CI stamps this before compilation; runtime configuration must never replace it.
    frontendBuildId: "4.27.0-ci.48",
    envName: 'DEFAULT',
    production: false,
    saasMode: true,
    // Development logging - disabled by default for deployed environments
    devLogging: {
        enabled: false,
        logApi: false,
        logConflicts: false,
        logPlanning: false,
        logState: false,
        logVerbose: false,
    },

    redirectUrl: '/pt4',
    tmsApiEndpointAddress: '/api/tms/v1/',
    hubEndpointAddress: '/client',
    tmsUserApiEndPointAddress: '/user/tms/v1/',
    ContainerPlanningApiUri: "/cp/v1/",

    // Authentication settings - MUST be provided by backend at runtime
    clientId: '',
    // Empty means "derive api://<clientId>/access_as_user". B2C tenants must override this with the
    // https:// scope from their app registration's Expose an API blade.
    apiScope: '',
    tenant: '',
    authority: '',

    // Application settings
    app_base_href: '/pt4',

    // Planning defaults
    defaultPlanningGroup: 'ALL',
    defaultPlanningZone: '',
    defaultPlanDaysAhead: 60,
    defaultPlanDaysBack: 60,

    // UI feature flags
    disableToSelectionModal: false,
    depotInIcon: false,
    depotOutIcon: false,
    collectionIcon: false,
    deliveryIcon: false,
    showWaitingRoom: false,
    iconType: "truck",
    maxDays: 7,
    stackerIcon: false,

    // TO (Transport Order) settings
    TODaysAhead: 60,
    TOdDaysBack: 60,

    // Business features
    shipping: false,
    railway: false,
    tarTasEnabled: false,
    withQuotes: false,

    // Authorization
    adminGroup: "PTADMINISTRATORS",
    MonitorAuthorizedUsers: "",
    enableAuthorizationModule: false,

    // Container features
    containerReleaseEnabled: false,
    containerPoolEnabled: false,

    // Business Central integration
    businessCentralUrl: '',
    businessCentralCompany: '',

    // Validation and checks
    checkOverlappingTos: false,
    disablePlanningGroupsCompatibilityCheck: false,

    // Monitoring
    instrumentationKey: "",

    // UI preferences
    showCompactPlanningMode: false,
    openEditOrderlineModalPosition: "middle",
    showReminders: false,
    printTicketAfterPlanning: false,

    // Feature flags
    useBulkPlanningFeature: true,

    // Depot settings
    depotDaysAhead: 60,
    depotDaysBack: 60,

    // Extended features object for feature toggles
    features: {
        chassisRightDockEnabled: false
    }
};
